module.exports = __webpack_public_path__ + "img/1255.607f28f2.gif";